@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_381_299_922)
internal val Res.string.quiz_aggettivo_sostantivato_tf_4: StringResource by lazy {
      StringResource("string:quiz_aggettivo_sostantivato_tf_4", "quiz_aggettivo_sostantivato_tf_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 205049, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 202305, 136),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 203382, 140),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 194165, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189729, 132),
      ))
    }

@delegate:ResourceContentHash(681_752_127)
internal val Res.string.quiz_btn: StringResource by lazy {
      StringResource("string:quiz_btn", "quiz_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 205190, 24),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 202442, 24),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 203523, 24),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 194294, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189862, 24),
      ))
    }

@delegate:ResourceContentHash(-1_006_979_863)
internal val Res.string.quiz_cartigli_due_nomi_in_cartiglio: StringResource by lazy {
      StringResource("string:quiz_cartigli_due_nomi_in_cartiglio", "quiz_cartigli_due_nomi_in_cartiglio", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 205215, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 202467, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 203548, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 194319, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 189887, 119),
      ))
    }

@delegate:ResourceContentHash(2_102_092_811)
internal val Res.string.quiz_cartigli_epiteto_solo_nomen: StringResource by lazy {
      StringResource("string:quiz_cartigli_epiteto_solo_nomen", "quiz_cartigli_epiteto_solo_nomen", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 205335, 132),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 202571, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 203692, 136),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 194423, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190007, 116),
      ))
    }

@delegate:ResourceContentHash(-986_899_794)
internal val Res.string.quiz_cartigli_tutankhamon_praenomen: StringResource by lazy {
      StringResource("string:quiz_cartigli_tutankhamon_praenomen", "quiz_cartigli_tutankhamon_praenomen", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 205468, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 202704, 115),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 203829, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 194552, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190124, 107),
      ))
    }

@delegate:ResourceContentHash(-1_755_248_280)
internal val Res.string.quiz_cartigli_tutankhamon_significato: StringResource by lazy {
      StringResource("string:quiz_cartigli_tutankhamon_significato", "quiz_cartigli_tutankhamon_significato", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 205572, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 202820, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 203949, 117),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 194668, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190232, 105),
      ))
    }

@delegate:ResourceContentHash(-317_016_846)
internal val Res.string.quiz_cartigli_tutti_cinque_nomi: StringResource by lazy {
      StringResource("string:quiz_cartigli_tutti_cinque_nomi", "quiz_cartigli_tutti_cinque_nomi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 205690, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 202934, 115),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 204067, 131),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 194782, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190338, 111),
      ))
    }

@delegate:ResourceContentHash(-1_544_288_093)
internal val Res.string.quiz_classi_verbali_1: StringResource by lazy {
      StringResource("string:quiz_classi_verbali_1", "quiz_classi_verbali_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 205806, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 203050, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 204199, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 194910, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190450, 105),
      ))
    }

@delegate:ResourceContentHash(526_596_660)
internal val Res.string.quiz_classi_verbali_2: StringResource by lazy {
      StringResource("string:quiz_classi_verbali_2", "quiz_classi_verbali_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 205916, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 203164, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 204321, 113),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 195020, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190556, 93),
      ))
    }

@delegate:ResourceContentHash(2_117_587_228)
internal val Res.string.quiz_classi_verbali_3: StringResource by lazy {
      StringResource("string:quiz_classi_verbali_3", "quiz_classi_verbali_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 206014, 121),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 203270, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 204435, 161),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 195122, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190650, 129),
      ))
    }

@delegate:ResourceContentHash(720_570_960)
internal val Res.string.quiz_classi_verbali_4: StringResource by lazy {
      StringResource("string:quiz_classi_verbali_4", "quiz_classi_verbali_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 206136, 137),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 203400, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 204597, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 195248, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190780, 117),
      ))
    }

@delegate:ResourceContentHash(-323_150_219)
internal val Res.string.quiz_classi_verbali_5: StringResource by lazy {
      StringResource("string:quiz_classi_verbali_5", "quiz_classi_verbali_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 206274, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 203542, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 204747, 145),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 195390, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 190898, 121),
      ))
    }

@delegate:ResourceContentHash(-2_126_829_881)
internal val Res.string.quiz_classi_verbali_6: StringResource by lazy {
      StringResource("string:quiz_classi_verbali_6", "quiz_classi_verbali_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 206404, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 203688, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 204893, 117),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 195528, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191020, 101),
      ))
    }

@delegate:ResourceContentHash(594_604_294)
internal val Res.string.quiz_classi_verbali_7: StringResource by lazy {
      StringResource("string:quiz_classi_verbali_7", "quiz_classi_verbali_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 206522, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 203810, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 205011, 101),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 195646, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191122, 81),
      ))
    }

@delegate:ResourceContentHash(252_829_654)
internal val Res.string.quiz_classi_verbali_8: StringResource by lazy {
      StringResource("string:quiz_classi_verbali_8", "quiz_classi_verbali_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 206616, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 203900, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 205113, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 195740, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191204, 141),
      ))
    }

@delegate:ResourceContentHash(-914_495_370)
internal val Res.string.quiz_completed_title: StringResource by lazy {
      StringResource("string:quiz_completed_title", "quiz_completed_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 206762, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 204026, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 205247, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 195866, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191346, 48),
      ))
    }

@delegate:ResourceContentHash(1_099_663_568)
internal val Res.string.quiz_frasi_avverbiali_1: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_1", "quiz_frasi_avverbiali_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 207240, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 204536, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 205789, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 196384, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191844, 115),
      ))
    }

@delegate:ResourceContentHash(-798_842_991)
internal val Res.string.quiz_frasi_avverbiali_10: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_10", "quiz_frasi_avverbiali_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 207127, 112),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 204423, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 205652, 136),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 196255, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191727, 116),
      ))
    }

@delegate:ResourceContentHash(-1_654_158_911)
internal val Res.string.quiz_frasi_avverbiali_10_opt1: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_10_opt1", "quiz_frasi_avverbiali_10_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 206819, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 204079, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 205296, 117),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 195919, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191395, 109),
      ))
    }

@delegate:ResourceContentHash(1_340_565_998)
internal val Res.string.quiz_frasi_avverbiali_10_opt2: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_10_opt2", "quiz_frasi_avverbiali_10_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 206913, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 204189, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 205414, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 196029, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191505, 65),
      ))
    }

@delegate:ResourceContentHash(-724_773_144)
internal val Res.string.quiz_frasi_avverbiali_10_opt3: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_10_opt3", "quiz_frasi_avverbiali_10_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 206979, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 204259, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 205480, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 196099, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191571, 73),
      ))
    }

@delegate:ResourceContentHash(1_718_186_208)
internal val Res.string.quiz_frasi_avverbiali_10_opt4: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_10_opt4", "quiz_frasi_avverbiali_10_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 207053, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 204337, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 205566, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 196169, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191645, 81),
      ))
    }

@delegate:ResourceContentHash(1_205_032_056)
internal val Res.string.quiz_frasi_avverbiali_2: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_2", "quiz_frasi_avverbiali_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 207352, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 204648, 131),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 205913, 143),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 196512, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191960, 139),
      ))
    }

@delegate:ResourceContentHash(977_551_849)
internal val Res.string.quiz_frasi_avverbiali_3: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_3", "quiz_frasi_avverbiali_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 207476, 155),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 204780, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 206057, 167),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 196648, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192100, 147),
      ))
    }

@delegate:ResourceContentHash(1_434_416_621)
internal val Res.string.quiz_frasi_avverbiali_4: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_4", "quiz_frasi_avverbiali_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 207632, 135),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 204936, 159),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 206225, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 196800, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192248, 131),
      ))
    }

@delegate:ResourceContentHash(477_562_429)
internal val Res.string.quiz_frasi_avverbiali_5: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_5", "quiz_frasi_avverbiali_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 207768, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 205096, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 206353, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 196956, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192380, 115),
      ))
    }

@delegate:ResourceContentHash(581_805_047)
internal val Res.string.quiz_frasi_avverbiali_6: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_6", "quiz_frasi_avverbiali_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 208088, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 205412, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 206665, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 197268, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192696, 119),
      ))
    }

@delegate:ResourceContentHash(1_906_998_447)
internal val Res.string.quiz_frasi_avverbiali_6_opt1: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_6_opt1", "quiz_frasi_avverbiali_6_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 207884, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 205220, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 206477, 52),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 197076, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192496, 60),
      ))
    }

@delegate:ResourceContentHash(-299_426_526)
internal val Res.string.quiz_frasi_avverbiali_6_opt2: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_6_opt2", "quiz_frasi_avverbiali_6_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 207945, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 205273, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 206530, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 197129, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192557, 48),
      ))
    }

@delegate:ResourceContentHash(-416_931_390)
internal val Res.string.quiz_frasi_avverbiali_6_opt3: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_6_opt3", "quiz_frasi_avverbiali_6_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 207994, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 205322, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 206579, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 197178, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192606, 48),
      ))
    }

@delegate:ResourceContentHash(555_533_279)
internal val Res.string.quiz_frasi_avverbiali_6_opt4: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_6_opt4", "quiz_frasi_avverbiali_6_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 208047, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 205371, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 206624, 40),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 197227, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192655, 40),
      ))
    }

@delegate:ResourceContentHash(1_829_439_010)
internal val Res.string.quiz_frasi_avverbiali_7: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_7", "quiz_frasi_avverbiali_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 208400, 131),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 205728, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 206997, 151),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 197588, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193024, 143),
      ))
    }

@delegate:ResourceContentHash(-160_817_871)
internal val Res.string.quiz_frasi_avverbiali_7_opt1: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_7_opt1", "quiz_frasi_avverbiali_7_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 208200, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 205524, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 206785, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 197380, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192816, 64),
      ))
    }

@delegate:ResourceContentHash(1_070_703_837)
internal val Res.string.quiz_frasi_avverbiali_7_opt2: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_7_opt2", "quiz_frasi_avverbiali_7_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 208257, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 205585, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 206850, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 197441, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192881, 56),
      ))
    }

@delegate:ResourceContentHash(-1_896_785_327)
internal val Res.string.quiz_frasi_avverbiali_7_opt3: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_7_opt3", "quiz_frasi_avverbiali_7_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 208314, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 205642, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 206911, 40),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 197502, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192938, 40),
      ))
    }

@delegate:ResourceContentHash(-1_689_650_023)
internal val Res.string.quiz_frasi_avverbiali_7_opt4: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_7_opt4", "quiz_frasi_avverbiali_7_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 208355, 44),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 205683, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 206952, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 197543, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 192979, 44),
      ))
    }

@delegate:ResourceContentHash(-2_123_382_824)
internal val Res.string.quiz_frasi_avverbiali_8: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_8", "quiz_frasi_avverbiali_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 208820, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 206164, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 207441, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 198016, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193452, 83),
      ))
    }

@delegate:ResourceContentHash(-1_942_982_314)
internal val Res.string.quiz_frasi_avverbiali_8_opt1: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_8_opt1", "quiz_frasi_avverbiali_8_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 208532, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 205872, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 207149, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 197724, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193168, 96),
      ))
    }

@delegate:ResourceContentHash(684_122_172)
internal val Res.string.quiz_frasi_avverbiali_8_opt2: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_8_opt2", "quiz_frasi_avverbiali_8_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 208633, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 205969, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 207246, 68),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 197821, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193265, 64),
      ))
    }

@delegate:ResourceContentHash(-437_307_547)
internal val Res.string.quiz_frasi_avverbiali_8_opt3: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_8_opt3", "quiz_frasi_avverbiali_8_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 208698, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 206038, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 207315, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 197886, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193330, 56),
      ))
    }

@delegate:ResourceContentHash(-526_776_915)
internal val Res.string.quiz_frasi_avverbiali_8_opt4: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_8_opt4", "quiz_frasi_avverbiali_8_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 208759, 60),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 206095, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 207372, 68),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 197947, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193387, 64),
      ))
    }

@delegate:ResourceContentHash(1_783_923_144)
internal val Res.string.quiz_frasi_avverbiali_9: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_9", "quiz_frasi_avverbiali_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 209216, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 206584, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 207845, 135),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 198440, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193872, 123),
      ))
    }

@delegate:ResourceContentHash(-817_915_906)
internal val Res.string.quiz_frasi_avverbiali_9_opt1: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_9_opt1", "quiz_frasi_avverbiali_9_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 208928, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 206252, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 207525, 104),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 198096, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193536, 108),
      ))
    }

@delegate:ResourceContentHash(-1_347_668_679)
internal val Res.string.quiz_frasi_avverbiali_9_opt2: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_9_opt2", "quiz_frasi_avverbiali_9_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 209033, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 206369, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 207630, 84),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 198221, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193645, 84),
      ))
    }

@delegate:ResourceContentHash(-1_996_682_189)
internal val Res.string.quiz_frasi_avverbiali_9_opt3: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_9_opt3", "quiz_frasi_avverbiali_9_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 209098, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 206454, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 207715, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 198302, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193730, 72),
      ))
    }

@delegate:ResourceContentHash(1_099_760_098)
internal val Res.string.quiz_frasi_avverbiali_9_opt4: StringResource by lazy {
      StringResource("string:quiz_frasi_avverbiali_9_opt4", "quiz_frasi_avverbiali_9_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 209151, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 206519, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 207780, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 198371, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193803, 68),
      ))
    }

@delegate:ResourceContentHash(502_247_608)
internal val Res.string.quiz_hiero_come_pronuncia: StringResource by lazy {
      StringResource("string:quiz_hiero_come_pronuncia", "quiz_hiero_come_pronuncia", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 209320, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 206728, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 207981, 97),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 198568, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 193996, 85),
      ))
    }

@delegate:ResourceContentHash(330_891_948)
internal val Res.string.quiz_hiero_cosa_determinativo: StringResource by lazy {
      StringResource("string:quiz_hiero_cosa_determinativo", "quiz_hiero_cosa_determinativo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 209410, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 206818, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 208079, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 198654, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194082, 97),
      ))
    }

@delegate:ResourceContentHash(-2_045_287_438)
internal val Res.string.quiz_hiero_logogramma: StringResource by lazy {
      StringResource("string:quiz_hiero_logogramma", "quiz_hiero_logogramma", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 209508, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 206916, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 208185, 89),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 198756, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194180, 69),
      ))
    }

@delegate:ResourceContentHash(1_084_572_151)
internal val Res.string.quiz_il_dimostrativo_pn_1: StringResource by lazy {
      StringResource("string:quiz_il_dimostrativo_pn_1", "quiz_il_dimostrativo_pn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 209838, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 207318, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 208559, 101),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 199130, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194554, 105),
      ))
    }

@delegate:ResourceContentHash(200_624_163)
internal val Res.string.quiz_il_dimostrativo_pn_1_opt1: StringResource by lazy {
      StringResource("string:quiz_il_dimostrativo_pn_1_opt1", "quiz_il_dimostrativo_pn_1_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 209574, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 207002, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 208275, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 198838, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194250, 66),
      ))
    }

@delegate:ResourceContentHash(793_802_350)
internal val Res.string.quiz_il_dimostrativo_pn_1_opt2: StringResource by lazy {
      StringResource("string:quiz_il_dimostrativo_pn_1_opt2", "quiz_il_dimostrativo_pn_1_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 209641, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 207081, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 208342, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 198905, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194317, 66),
      ))
    }

@delegate:ResourceContentHash(-229_005_011)
internal val Res.string.quiz_il_dimostrativo_pn_1_opt3: StringResource by lazy {
      StringResource("string:quiz_il_dimostrativo_pn_1_opt3", "quiz_il_dimostrativo_pn_1_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 209708, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 207156, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 208405, 78),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 198972, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194384, 86),
      ))
    }

@delegate:ResourceContentHash(359_754_825)
internal val Res.string.quiz_il_dimostrativo_pn_1_opt4: StringResource by lazy {
      StringResource("string:quiz_il_dimostrativo_pn_1_opt4", "quiz_il_dimostrativo_pn_1_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 209775, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 207239, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 208484, 74),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 199051, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194471, 82),
      ))
    }

@delegate:ResourceContentHash(-297_468_736)
internal val Res.string.quiz_il_dimostrativo_pn_2: StringResource by lazy {
      StringResource("string:quiz_il_dimostrativo_pn_2", "quiz_il_dimostrativo_pn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 210096, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 207592, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 208833, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 199396, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194832, 113),
      ))
    }

@delegate:ResourceContentHash(1_986_902_828)
internal val Res.string.quiz_il_dimostrativo_pn_2_opt1: StringResource by lazy {
      StringResource("string:quiz_il_dimostrativo_pn_2_opt1", "quiz_il_dimostrativo_pn_2_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 209924, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 207420, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 208661, 42),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 199224, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194660, 42),
      ))
    }

@delegate:ResourceContentHash(-672_993_651)
internal val Res.string.quiz_il_dimostrativo_pn_2_opt2: StringResource by lazy {
      StringResource("string:quiz_il_dimostrativo_pn_2_opt2", "quiz_il_dimostrativo_pn_2_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 209967, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 207463, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 208704, 42),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 199267, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194703, 42),
      ))
    }

@delegate:ResourceContentHash(1_451_648_788)
internal val Res.string.quiz_il_dimostrativo_pn_2_opt3: StringResource by lazy {
      StringResource("string:quiz_il_dimostrativo_pn_2_opt3", "quiz_il_dimostrativo_pn_2_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 210010, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 207506, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 208747, 42),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 199310, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194746, 42),
      ))
    }

@delegate:ResourceContentHash(-1_068_311_208)
internal val Res.string.quiz_il_dimostrativo_pn_2_opt4: StringResource by lazy {
      StringResource("string:quiz_il_dimostrativo_pn_2_opt4", "quiz_il_dimostrativo_pn_2_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 210053, 42),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 207549, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 208790, 42),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 199353, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194789, 42),
      ))
    }

@delegate:ResourceContentHash(-1_895_622_631)
internal val Res.string.quiz_intro_hiero2_bilitteri: StringResource by lazy {
      StringResource("string:quiz_intro_hiero2_bilitteri", "quiz_intro_hiero2_bilitteri", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 210230, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 207710, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 208955, 95),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 199510, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194946, 83),
      ))
    }

@delegate:ResourceContentHash(235_726_643)
internal val Res.string.quiz_intro_hiero2_consonanti: StringResource by lazy {
      StringResource("string:quiz_intro_hiero2_consonanti", "quiz_intro_hiero2_consonanti", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 210322, 120),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 207806, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 209051, 136),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 199602, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195030, 116),
      ))
    }

@delegate:ResourceContentHash(1_277_138_709)
internal val Res.string.quiz_intro_hiero2_fonogrammi: StringResource by lazy {
      StringResource("string:quiz_intro_hiero2_fonogrammi", "quiz_intro_hiero2_fonogrammi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 210443, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 207931, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 209188, 92),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 199723, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195147, 76),
      ))
    }

@delegate:ResourceContentHash(899_572_641)
internal val Res.string.quiz_intro_hiero2_ideogrammi: StringResource by lazy {
      StringResource("string:quiz_intro_hiero2_ideogrammi", "quiz_intro_hiero2_ideogrammi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 210520, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 208016, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 209281, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 199804, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195224, 88),
      ))
    }

@delegate:ResourceContentHash(256_005_663)
internal val Res.string.quiz_intro_hiero2_monolitteri: StringResource by lazy {
      StringResource("string:quiz_intro_hiero2_monolitteri", "quiz_intro_hiero2_monolitteri", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 210740, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 208240, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 209525, 101),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 200024, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195416, 85),
      ))
    }

@delegate:ResourceContentHash(2_014_978_514)
internal val Res.string.quiz_intro_hiero2_monolitteri_soli: StringResource by lazy {
      StringResource("string:quiz_intro_hiero2_monolitteri_soli", "quiz_intro_hiero2_monolitteri_soli", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 210621, 118),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 208117, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 209390, 134),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 199909, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195313, 102),
      ))
    }

@delegate:ResourceContentHash(1_905_300_868)
internal val Res.string.quiz_intro_hiero2_nessun_nome: StringResource by lazy {
      StringResource("string:quiz_intro_hiero2_nessun_nome", "quiz_intro_hiero2_nessun_nome", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 210830, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 208342, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 209627, 113),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 200118, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195502, 105),
      ))
    }

@delegate:ResourceContentHash(1_088_374_657)
internal val Res.string.quiz_intro_hiero2_trattino: StringResource by lazy {
      StringResource("string:quiz_intro_hiero2_trattino", "quiz_intro_hiero2_trattino", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 210960, 130),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 208452, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 209741, 110),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 200224, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195608, 114),
      ))
    }

@delegate:ResourceContentHash(1_769_875_336)
internal val Res.string.quiz_intro_hiero2_trilitteri: StringResource by lazy {
      StringResource("string:quiz_intro_hiero2_trilitteri", "quiz_intro_hiero2_trilitteri", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 211091, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 208559, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 209852, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 200331, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195723, 84),
      ))
    }

@delegate:ResourceContentHash(1_126_339_226)
internal val Res.string.quiz_intro_hiero2_vocali_e: StringResource by lazy {
      StringResource("string:quiz_intro_hiero2_vocali_e", "quiz_intro_hiero2_vocali_e", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 211184, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 208656, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 209949, 118),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 200424, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195808, 98),
      ))
    }

@delegate:ResourceContentHash(2_051_362_167)
internal val Res.string.quiz_intro_hiero_calibrati: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_calibrati", "quiz_intro_hiero_calibrati", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 211295, 142),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 208763, 142),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 210068, 150),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 200539, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 195907, 130),
      ))
    }

@delegate:ResourceContentHash(-1_477_532_027)
internal val Res.string.quiz_intro_hiero_colore: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_colore", "quiz_intro_hiero_colore", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 211438, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 208906, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 210219, 139),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 200670, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196038, 135),
      ))
    }

@delegate:ResourceContentHash(-547_483_912)
internal val Res.string.quiz_intro_hiero_lettura_bidirezionale: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_lettura_bidirezionale", "quiz_intro_hiero_lettura_bidirezionale", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 211558, 162),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 209050, 174),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 210359, 162),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 200806, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196174, 142),
      ))
    }

@delegate:ResourceContentHash(-1_148_385_751)
internal val Res.string.quiz_intro_hiero_multi_1: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_multi_1", "quiz_intro_hiero_multi_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 211721, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 209225, 140),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 210522, 144),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 200969, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196317, 120),
      ))
    }

@delegate:ResourceContentHash(1_161_039_125)
internal val Res.string.quiz_intro_hiero_multi_2: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_multi_2", "quiz_intro_hiero_multi_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 211838, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 209366, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 210667, 124),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 201102, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196438, 100),
      ))
    }

@delegate:ResourceContentHash(-1_631_221_495)
internal val Res.string.quiz_intro_hiero_opt_calibrati: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_opt_calibrati", "quiz_intro_hiero_opt_calibrati", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 211947, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 209491, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 210792, 134),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 201219, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196539, 118),
      ))
    }

@delegate:ResourceContentHash(2_088_403_228)
internal val Res.string.quiz_intro_hiero_opt_direzione: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_opt_direzione", "quiz_intro_hiero_opt_direzione", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 212074, 138),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 209622, 146),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 210927, 138),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 201338, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196658, 138),
      ))
    }

@delegate:ResourceContentHash(210_026_445)
internal val Res.string.quiz_intro_hiero_opt_quadrati: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_opt_quadrati", "quiz_intro_hiero_opt_quadrati", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 212213, 105),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 209769, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 211066, 109),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 201477, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196797, 89),
      ))
    }

@delegate:ResourceContentHash(-323_570_700)
internal val Res.string.quiz_intro_hiero_opt_ridurre: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_opt_ridurre", "quiz_intro_hiero_opt_ridurre", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 212319, 112),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 209867, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 211176, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 201571, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196887, 96),
      ))
    }

@delegate:ResourceContentHash(1_336_546_713)
internal val Res.string.quiz_intro_hiero_opt_spazi: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_opt_spazi", "quiz_intro_hiero_opt_spazi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 212545, 130),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 210081, 142),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 211394, 146),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 201765, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197081, 114),
      ))
    }

@delegate:ResourceContentHash(1_205_464_336)
internal val Res.string.quiz_intro_hiero_opt_spazi_vuoti: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_opt_spazi_vuoti", "quiz_intro_hiero_opt_spazi_vuoti", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 212432, 112),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 209980, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 211285, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 201676, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196984, 96),
      ))
    }

@delegate:ResourceContentHash(-862_590_089)
internal val Res.string.quiz_intro_hiero_opt_trasporre: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_opt_trasporre", "quiz_intro_hiero_opt_trasporre", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 212790, 130),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 210334, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 211655, 138),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 202002, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197290, 110),
      ))
    }

@delegate:ResourceContentHash(556_985_819)
internal val Res.string.quiz_intro_hiero_opt_trasporre_parola: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_opt_trasporre_parola", "quiz_intro_hiero_opt_trasporre_parola", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 212676, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 210224, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 211541, 113),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 201892, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197196, 93),
      ))
    }

@delegate:ResourceContentHash(456_169_065)
internal val Res.string.quiz_intro_hiero_papera_giraffa: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_papera_giraffa", "quiz_intro_hiero_papera_giraffa", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 212921, 135),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 210473, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 211794, 135),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 202133, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197401, 127),
      ))
    }

@delegate:ResourceContentHash(740_138_867)
internal val Res.string.quiz_intro_hiero_quadrati: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_quadrati", "quiz_intro_hiero_quadrati", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 213057, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 210609, 157),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 211930, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 202269, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197529, 117),
      ))
    }

@delegate:ResourceContentHash(44_688_616)
internal val Res.string.quiz_intro_hiero_simboli_direzione: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_simboli_direzione", "quiz_intro_hiero_simboli_direzione", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 213199, 154),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 210767, 166),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 212080, 154),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 202427, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197647, 150),
      ))
    }

@delegate:ResourceContentHash(1_631_175_025)
internal val Res.string.quiz_intro_hiero_spazi_vuoti: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_spazi_vuoti", "quiz_intro_hiero_spazi_vuoti", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 213354, 132),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 210934, 148),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 212235, 148),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 202574, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197798, 116),
      ))
    }

@delegate:ResourceContentHash(-92_985_593)
internal val Res.string.quiz_intro_hiero_trasposti: StringResource by lazy {
      StringResource("string:quiz_intro_hiero_trasposti", "quiz_intro_hiero_trasposti", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 213487, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 211083, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 212384, 138),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 202711, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197915, 110),
      ))
    }

@delegate:ResourceContentHash(-1_487_098_363)
internal val Res.string.quiz_le_preposizioni_1: StringResource by lazy {
      StringResource("string:quiz_le_preposizioni_1", "quiz_le_preposizioni_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 213790, 134),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 211398, 150),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 212703, 142),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 203018, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198206, 138),
      ))
    }

@delegate:ResourceContentHash(-2_113_903_204)
internal val Res.string.quiz_le_preposizioni_1_opt1: StringResource by lazy {
      StringResource("string:quiz_le_preposizioni_1_opt1", "quiz_le_preposizioni_1_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 213614, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 211218, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 212523, 43),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 202838, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198026, 43),
      ))
    }

@delegate:ResourceContentHash(357_831_702)
internal val Res.string.quiz_le_preposizioni_1_opt2: StringResource by lazy {
      StringResource("string:quiz_le_preposizioni_1_opt2", "quiz_le_preposizioni_1_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 213658, 43),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 211262, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 212567, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 202882, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198070, 47),
      ))
    }

@delegate:ResourceContentHash(1_809_264_719)
internal val Res.string.quiz_le_preposizioni_1_opt3: StringResource by lazy {
      StringResource("string:quiz_le_preposizioni_1_opt3", "quiz_le_preposizioni_1_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 213702, 39),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 211310, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 212615, 39),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 202930, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198118, 39),
      ))
    }

@delegate:ResourceContentHash(-930_224_486)
internal val Res.string.quiz_le_preposizioni_1_opt4: StringResource by lazy {
      StringResource("string:quiz_le_preposizioni_1_opt4", "quiz_le_preposizioni_1_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 213742, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 211350, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 212655, 47),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 202970, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198158, 47),
      ))
    }

@delegate:ResourceContentHash(712_880_851)
internal val Res.string.quiz_le_preposizioni_2: StringResource by lazy {
      StringResource("string:quiz_le_preposizioni_2", "quiz_le_preposizioni_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 214157, 174),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 211781, 150),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 213094, 154),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 203381, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198569, 142),
      ))
    }

@delegate:ResourceContentHash(-1_339_164_651)
internal val Res.string.quiz_le_preposizioni_2_opt1: StringResource by lazy {
      StringResource("string:quiz_le_preposizioni_2_opt1", "quiz_le_preposizioni_2_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 213925, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 211549, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 212846, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 203149, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198345, 51),
      ))
    }

@delegate:ResourceContentHash(1_611_192_916)
internal val Res.string.quiz_le_preposizioni_2_opt2: StringResource by lazy {
      StringResource("string:quiz_le_preposizioni_2_opt2", "quiz_le_preposizioni_2_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 213977, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 211601, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 212902, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 203201, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198397, 55),
      ))
    }

@delegate:ResourceContentHash(-1_798_201_633)
internal val Res.string.quiz_le_preposizioni_2_opt3: StringResource by lazy {
      StringResource("string:quiz_le_preposizioni_2_opt3", "quiz_le_preposizioni_2_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 214033, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 211661, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 212962, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 203261, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198453, 51),
      ))
    }

@delegate:ResourceContentHash(1_522_695_576)
internal val Res.string.quiz_le_preposizioni_2_opt4: StringResource by lazy {
      StringResource("string:quiz_le_preposizioni_2_opt4", "quiz_le_preposizioni_2_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 214085, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 211717, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 213018, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 203317, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198505, 63),
      ))
    }

@delegate:ResourceContentHash(634_781_514)
internal val Res.string.quiz_le_preposizioni_3: StringResource by lazy {
      StringResource("string:quiz_le_preposizioni_3", "quiz_le_preposizioni_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 214604, 154),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 212176, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 213505, 150),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 203760, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198960, 130),
      ))
    }

@delegate:ResourceContentHash(1_933_245_385)
internal val Res.string.quiz_le_preposizioni_3_opt1: StringResource by lazy {
      StringResource("string:quiz_le_preposizioni_3_opt1", "quiz_le_preposizioni_3_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 214332, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 211932, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 213249, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 203532, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198712, 55),
      ))
    }

@delegate:ResourceContentHash(-419_789_575)
internal val Res.string.quiz_le_preposizioni_3_opt2: StringResource by lazy {
      StringResource("string:quiz_le_preposizioni_3_opt2", "quiz_le_preposizioni_3_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 214396, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 211988, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 213313, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 203584, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198768, 79),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString20Resources(map: MutableMap<String, StringResource>) {
  map.put("quiz_aggettivo_sostantivato_tf_4", Res.string.quiz_aggettivo_sostantivato_tf_4)
  map.put("quiz_btn", Res.string.quiz_btn)
  map.put("quiz_cartigli_due_nomi_in_cartiglio", Res.string.quiz_cartigli_due_nomi_in_cartiglio)
  map.put("quiz_cartigli_epiteto_solo_nomen", Res.string.quiz_cartigli_epiteto_solo_nomen)
  map.put("quiz_cartigli_tutankhamon_praenomen", Res.string.quiz_cartigli_tutankhamon_praenomen)
  map.put("quiz_cartigli_tutankhamon_significato", Res.string.quiz_cartigli_tutankhamon_significato)
  map.put("quiz_cartigli_tutti_cinque_nomi", Res.string.quiz_cartigli_tutti_cinque_nomi)
  map.put("quiz_classi_verbali_1", Res.string.quiz_classi_verbali_1)
  map.put("quiz_classi_verbali_2", Res.string.quiz_classi_verbali_2)
  map.put("quiz_classi_verbali_3", Res.string.quiz_classi_verbali_3)
  map.put("quiz_classi_verbali_4", Res.string.quiz_classi_verbali_4)
  map.put("quiz_classi_verbali_5", Res.string.quiz_classi_verbali_5)
  map.put("quiz_classi_verbali_6", Res.string.quiz_classi_verbali_6)
  map.put("quiz_classi_verbali_7", Res.string.quiz_classi_verbali_7)
  map.put("quiz_classi_verbali_8", Res.string.quiz_classi_verbali_8)
  map.put("quiz_completed_title", Res.string.quiz_completed_title)
  map.put("quiz_frasi_avverbiali_1", Res.string.quiz_frasi_avverbiali_1)
  map.put("quiz_frasi_avverbiali_10", Res.string.quiz_frasi_avverbiali_10)
  map.put("quiz_frasi_avverbiali_10_opt1", Res.string.quiz_frasi_avverbiali_10_opt1)
  map.put("quiz_frasi_avverbiali_10_opt2", Res.string.quiz_frasi_avverbiali_10_opt2)
  map.put("quiz_frasi_avverbiali_10_opt3", Res.string.quiz_frasi_avverbiali_10_opt3)
  map.put("quiz_frasi_avverbiali_10_opt4", Res.string.quiz_frasi_avverbiali_10_opt4)
  map.put("quiz_frasi_avverbiali_2", Res.string.quiz_frasi_avverbiali_2)
  map.put("quiz_frasi_avverbiali_3", Res.string.quiz_frasi_avverbiali_3)
  map.put("quiz_frasi_avverbiali_4", Res.string.quiz_frasi_avverbiali_4)
  map.put("quiz_frasi_avverbiali_5", Res.string.quiz_frasi_avverbiali_5)
  map.put("quiz_frasi_avverbiali_6", Res.string.quiz_frasi_avverbiali_6)
  map.put("quiz_frasi_avverbiali_6_opt1", Res.string.quiz_frasi_avverbiali_6_opt1)
  map.put("quiz_frasi_avverbiali_6_opt2", Res.string.quiz_frasi_avverbiali_6_opt2)
  map.put("quiz_frasi_avverbiali_6_opt3", Res.string.quiz_frasi_avverbiali_6_opt3)
  map.put("quiz_frasi_avverbiali_6_opt4", Res.string.quiz_frasi_avverbiali_6_opt4)
  map.put("quiz_frasi_avverbiali_7", Res.string.quiz_frasi_avverbiali_7)
  map.put("quiz_frasi_avverbiali_7_opt1", Res.string.quiz_frasi_avverbiali_7_opt1)
  map.put("quiz_frasi_avverbiali_7_opt2", Res.string.quiz_frasi_avverbiali_7_opt2)
  map.put("quiz_frasi_avverbiali_7_opt3", Res.string.quiz_frasi_avverbiali_7_opt3)
  map.put("quiz_frasi_avverbiali_7_opt4", Res.string.quiz_frasi_avverbiali_7_opt4)
  map.put("quiz_frasi_avverbiali_8", Res.string.quiz_frasi_avverbiali_8)
  map.put("quiz_frasi_avverbiali_8_opt1", Res.string.quiz_frasi_avverbiali_8_opt1)
  map.put("quiz_frasi_avverbiali_8_opt2", Res.string.quiz_frasi_avverbiali_8_opt2)
  map.put("quiz_frasi_avverbiali_8_opt3", Res.string.quiz_frasi_avverbiali_8_opt3)
  map.put("quiz_frasi_avverbiali_8_opt4", Res.string.quiz_frasi_avverbiali_8_opt4)
  map.put("quiz_frasi_avverbiali_9", Res.string.quiz_frasi_avverbiali_9)
  map.put("quiz_frasi_avverbiali_9_opt1", Res.string.quiz_frasi_avverbiali_9_opt1)
  map.put("quiz_frasi_avverbiali_9_opt2", Res.string.quiz_frasi_avverbiali_9_opt2)
  map.put("quiz_frasi_avverbiali_9_opt3", Res.string.quiz_frasi_avverbiali_9_opt3)
  map.put("quiz_frasi_avverbiali_9_opt4", Res.string.quiz_frasi_avverbiali_9_opt4)
  map.put("quiz_hiero_come_pronuncia", Res.string.quiz_hiero_come_pronuncia)
  map.put("quiz_hiero_cosa_determinativo", Res.string.quiz_hiero_cosa_determinativo)
  map.put("quiz_hiero_logogramma", Res.string.quiz_hiero_logogramma)
  map.put("quiz_il_dimostrativo_pn_1", Res.string.quiz_il_dimostrativo_pn_1)
  map.put("quiz_il_dimostrativo_pn_1_opt1", Res.string.quiz_il_dimostrativo_pn_1_opt1)
  map.put("quiz_il_dimostrativo_pn_1_opt2", Res.string.quiz_il_dimostrativo_pn_1_opt2)
  map.put("quiz_il_dimostrativo_pn_1_opt3", Res.string.quiz_il_dimostrativo_pn_1_opt3)
  map.put("quiz_il_dimostrativo_pn_1_opt4", Res.string.quiz_il_dimostrativo_pn_1_opt4)
  map.put("quiz_il_dimostrativo_pn_2", Res.string.quiz_il_dimostrativo_pn_2)
  map.put("quiz_il_dimostrativo_pn_2_opt1", Res.string.quiz_il_dimostrativo_pn_2_opt1)
  map.put("quiz_il_dimostrativo_pn_2_opt2", Res.string.quiz_il_dimostrativo_pn_2_opt2)
  map.put("quiz_il_dimostrativo_pn_2_opt3", Res.string.quiz_il_dimostrativo_pn_2_opt3)
  map.put("quiz_il_dimostrativo_pn_2_opt4", Res.string.quiz_il_dimostrativo_pn_2_opt4)
  map.put("quiz_intro_hiero2_bilitteri", Res.string.quiz_intro_hiero2_bilitteri)
  map.put("quiz_intro_hiero2_consonanti", Res.string.quiz_intro_hiero2_consonanti)
  map.put("quiz_intro_hiero2_fonogrammi", Res.string.quiz_intro_hiero2_fonogrammi)
  map.put("quiz_intro_hiero2_ideogrammi", Res.string.quiz_intro_hiero2_ideogrammi)
  map.put("quiz_intro_hiero2_monolitteri", Res.string.quiz_intro_hiero2_monolitteri)
  map.put("quiz_intro_hiero2_monolitteri_soli", Res.string.quiz_intro_hiero2_monolitteri_soli)
  map.put("quiz_intro_hiero2_nessun_nome", Res.string.quiz_intro_hiero2_nessun_nome)
  map.put("quiz_intro_hiero2_trattino", Res.string.quiz_intro_hiero2_trattino)
  map.put("quiz_intro_hiero2_trilitteri", Res.string.quiz_intro_hiero2_trilitteri)
  map.put("quiz_intro_hiero2_vocali_e", Res.string.quiz_intro_hiero2_vocali_e)
  map.put("quiz_intro_hiero_calibrati", Res.string.quiz_intro_hiero_calibrati)
  map.put("quiz_intro_hiero_colore", Res.string.quiz_intro_hiero_colore)
  map.put("quiz_intro_hiero_lettura_bidirezionale", Res.string.quiz_intro_hiero_lettura_bidirezionale)
  map.put("quiz_intro_hiero_multi_1", Res.string.quiz_intro_hiero_multi_1)
  map.put("quiz_intro_hiero_multi_2", Res.string.quiz_intro_hiero_multi_2)
  map.put("quiz_intro_hiero_opt_calibrati", Res.string.quiz_intro_hiero_opt_calibrati)
  map.put("quiz_intro_hiero_opt_direzione", Res.string.quiz_intro_hiero_opt_direzione)
  map.put("quiz_intro_hiero_opt_quadrati", Res.string.quiz_intro_hiero_opt_quadrati)
  map.put("quiz_intro_hiero_opt_ridurre", Res.string.quiz_intro_hiero_opt_ridurre)
  map.put("quiz_intro_hiero_opt_spazi", Res.string.quiz_intro_hiero_opt_spazi)
  map.put("quiz_intro_hiero_opt_spazi_vuoti", Res.string.quiz_intro_hiero_opt_spazi_vuoti)
  map.put("quiz_intro_hiero_opt_trasporre", Res.string.quiz_intro_hiero_opt_trasporre)
  map.put("quiz_intro_hiero_opt_trasporre_parola", Res.string.quiz_intro_hiero_opt_trasporre_parola)
  map.put("quiz_intro_hiero_papera_giraffa", Res.string.quiz_intro_hiero_papera_giraffa)
  map.put("quiz_intro_hiero_quadrati", Res.string.quiz_intro_hiero_quadrati)
  map.put("quiz_intro_hiero_simboli_direzione", Res.string.quiz_intro_hiero_simboli_direzione)
  map.put("quiz_intro_hiero_spazi_vuoti", Res.string.quiz_intro_hiero_spazi_vuoti)
  map.put("quiz_intro_hiero_trasposti", Res.string.quiz_intro_hiero_trasposti)
  map.put("quiz_le_preposizioni_1", Res.string.quiz_le_preposizioni_1)
  map.put("quiz_le_preposizioni_1_opt1", Res.string.quiz_le_preposizioni_1_opt1)
  map.put("quiz_le_preposizioni_1_opt2", Res.string.quiz_le_preposizioni_1_opt2)
  map.put("quiz_le_preposizioni_1_opt3", Res.string.quiz_le_preposizioni_1_opt3)
  map.put("quiz_le_preposizioni_1_opt4", Res.string.quiz_le_preposizioni_1_opt4)
  map.put("quiz_le_preposizioni_2", Res.string.quiz_le_preposizioni_2)
  map.put("quiz_le_preposizioni_2_opt1", Res.string.quiz_le_preposizioni_2_opt1)
  map.put("quiz_le_preposizioni_2_opt2", Res.string.quiz_le_preposizioni_2_opt2)
  map.put("quiz_le_preposizioni_2_opt3", Res.string.quiz_le_preposizioni_2_opt3)
  map.put("quiz_le_preposizioni_2_opt4", Res.string.quiz_le_preposizioni_2_opt4)
  map.put("quiz_le_preposizioni_3", Res.string.quiz_le_preposizioni_3)
  map.put("quiz_le_preposizioni_3_opt1", Res.string.quiz_le_preposizioni_3_opt1)
  map.put("quiz_le_preposizioni_3_opt2", Res.string.quiz_le_preposizioni_3_opt2)
}
